import React, { Component } from 'react';
import { Button, Form, Input, FormGroup, FormFeedback } from 'reactstrap';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import './login.scss';
import Logo from '../../logo';
import { login, setUserDetails } from './action';
import { setLoginCredentials, setToken, getUserInfo, loggedIn } from '../../../helper';
import Preloader from '../../../components/UI/Preloader';
import { Preloading } from './../../UI/Preloader/action';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getCoporateDetails } from '../../Services/action';
import { setUserId } from '../../GoogleAnalytics/index';
/* import withAuth from '../Services/WithAuth';
import AuthService from '../../components/Services/AuthService' */

class TheodoreLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formErrors: { username: '', password: '' },
            userNameValid: false,
            passwordValid: false,
            formValid: false,
            userInfo: ""
        };
    }
    componentDidMount() {
        if (loggedIn()) { }
        //   this.props.history.push('/');
    }

    componentWillUnmount() {
        this.props.preloading(false);
    }

    componentDidUpdate(prevProps) {
        if (this.props.corporateDetails !== prevProps.corporateDetails) {
            const tempFlag = setUserId(this.props.corporateDetails, this.state.userInfo);
            if (tempFlag) {
                this.props.setUserDetails(this.state.userInfo);
                this.props.preloading(false);
            }
        }
        if (this.props.loginSuccess.hasOwnProperty('token') &&
            !prevProps.loginSuccess.hasOwnProperty('token')) {
            setToken(this.props.loginSuccess);
            let tempUserInfo = getUserInfo();
            if (tempUserInfo.scopes[0] === 'ROLE_CORPORATE') {
                this.props.getCoporateDetails(tempUserInfo.corporateId);
                this.setState({
                    userInfo: tempUserInfo
                })
            } else {
                this.props.setUserDetails(tempUserInfo);
                this.props.preloading(false);
            }

        } else if (this.props.loginFailure !== prevProps.loginFailure) { 
            toast.error(
                <div>
                     <i className="fa fa-warning"></i>&nbsp;{this.props.loginFailure?.errorMessage || "Something went wrong! Please try again."}
                </div>
            );
            this.props.preloading(false);
        }
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let userNameValid = this.state.userNameValid;
        let passwordValid = this.state.passwordValid;

        switch (fieldName) {
            case 'username':
                // emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                userNameValid = value.length > 0;
                fieldValidationErrors.username = userNameValid ? '' : 'Enter a Valid Theodore Username';
                break;
            case 'password':
                passwordValid = value.length >= 4;
                fieldValidationErrors.password = passwordValid ? '' : 'Password is too short';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            userNameValid: userNameValid,
            passwordValid: passwordValid
        }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.userNameValid && this.state.passwordValid });
    }
    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value }, () => { this.validateField(name, value) });
    }
    doLogin = (event) => {
        this.props.preloading(true);
        event.preventDefault();
        const userInfoCredentials = setLoginCredentials((this.state.username).trim(), (this.state.password).trim());
        this.props.login(userInfoCredentials);
    }

    render() {
        return (
            <section className="d-flex align-items-center justify-content-center h-100vh">
                <section className="pre-login">
                    <Form>
                        <Logo propClassName="mb-5" />
                        <FormGroup className="mb-4">
                            <Input type="text" name="username" id="username" placeholder="Rubix User id" className={this.state.formErrors.username ? 'is-invalid' : ''} onChange={this.handleUserInput} required />
                            <FormFeedback className="text-left">{this.state.formErrors.username}</FormFeedback>
                        </FormGroup>
                        <FormGroup className="mb-4">
                            <Input type="password" name="password" id="password" placeholder="PASSWORD" className={this.state.formErrors.password ? 'is-invalid' : ''} onChange={this.handleUserInput} required />
                            <FormFeedback className="text-left">{this.state.formErrors.password}</FormFeedback>
                        </FormGroup>
                        <Button size="lg" name="btn-login" color="primary" type="submit" className="mb-2 btn-submit" block disabled={!this.state.formValid} onClick={this.doLogin}>SIGN IN</Button>
                    </Form>
                    <Link className="px-0" to="/forgot">Forgot Password ?</Link>
                </section>

                <Preloader></Preloader>
                <ToastContainer hideProgressBar={true} position="top-center" autoClose={3000}></ToastContainer>
            </section>

        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    loginSuccess: state.loginDetails.loginSuccess,
    loginFailure: state.loginDetails.loginFailure,
    corporateDetails: state.commonReducer.corporateSuccess,
    corporateDetailsFailure: state.commonReducer.corporateFailure
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    login: (data) => { dispatch(login(data)) },
    setUserDetails: (data) => { dispatch(setUserDetails(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    getCoporateDetails: (data) => { dispatch(getCoporateDetails(data)) }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TheodoreLogin);